import React from 'react';
import { CartItemPrice } from '../CartItemPrice';
import { toTitleCase } from 'helpers/strings';
import {
  AddOnHeader,
  AddOnRow,
  AddOnsContainer,
  AddOnsTitle,
  AddOnText,
  CartItemOptionDetailsContainer,
  DependentOption,
  Header,
  Includes,
  OptionName,
  ProductName
} from './styled';

export interface OptionPriceDetails {
  optionName: string;
  optionTitle: string;
  optionValue: string | number;
  additionalPrice: number;
  additionalPageCountPriceString?: string;
  dependsOnName?: string;
  dependsOnValue?: string;
  dependentOptions?: OptionPriceDetails[];
}

export interface CartItemOptionsDetails {
  defaultProductOptions?: OptionPriceDetails[];
  upchargedProductOptions?: OptionPriceDetails[];
}

interface CartItemOptionDetailsProps {
  productName: string;
  productBasePrice: number;
  basePageCount?: number;
  options: CartItemOptionsDetails;
  isDeviceSmall: boolean;
}

export const CartItemOptionDetails = ({
  options,
  productName,
  productBasePrice,
  basePageCount = 0,
  isDeviceSmall
}: CartItemOptionDetailsProps): JSX.Element => {
  return (
    <CartItemOptionDetailsContainer isDeviceSmall={isDeviceSmall}>
      <Header>
        <ProductName>{productName}</ProductName>
        <CartItemPrice
          price={productBasePrice}
          qty={1}
          baseDiscountAmount={0}
          isCartItemFetching={false}
          isCartTransparencyTestOn={true}
          isDetailPrice={true}
        />
      </Header>

      <Includes title="includes">
        Includes
        {basePageCount > 0 && ` ${basePageCount} Page Count, `}
        {options.defaultProductOptions
          .map((defaultOption) => {
            return ` ${toTitleCase(defaultOption.optionValue.toString())} ${toTitleCase(defaultOption.optionName)}`;
          })
          .join(', ')}
      </Includes>

      {options.upchargedProductOptions?.length > 0 && (
        <AddOnsContainer>
          <AddOnsTitle>ADD-ONS</AddOnsTitle>

          {options.upchargedProductOptions.map(
            (option, index) =>
              option.additionalPrice > 0 && (
                <AddOnRow key={index}>
                  <AddOnHeader>
                    {option.additionalPageCountPriceString?.length ? (
                      <AddOnText>{option.additionalPageCountPriceString}</AddOnText>
                    ) : (
                      <AddOnText>
                        <OptionName>{`${toTitleCase(option.optionName.toString())} `}</OptionName>
                        <span>{toTitleCase(option.optionValue.toString())}</span>
                      </AddOnText>
                    )}

                    <CartItemPrice
                      price={option.additionalPrice}
                      qty={1}
                      baseDiscountAmount={0}
                      isCartItemFetching={false}
                      isCartTransparencyTestOn={true}
                      isDetailPrice={true}
                      showPlus={true}
                    />
                  </AddOnHeader>

                  {option.dependentOptions?.map((dependentOption, subIndex) => (
                    <DependentOption key={subIndex}>
                      <OptionName>{`${toTitleCase(dependentOption.optionName.toString())}: `}</OptionName>
                      <span>{toTitleCase(dependentOption.optionValue.toString())}</span>
                    </DependentOption>
                  ))}
                </AddOnRow>
              )
          )}
        </AddOnsContainer>
      )}
    </CartItemOptionDetailsContainer>
  );
};
